import { Icon, IconName } from "@nju/icons";
import { BlockText, Text } from "@nju/ui";

interface IDetailsSectionProps {
  iconName: IconName;
  title: string;
  description: string;
}

export function DetailsSection({
  iconName,
  title,
  description,
}: IDetailsSectionProps) {
  return (
    <div className="flex items-center gap-3">
      <Icon height={30} name={iconName} tone="accent" width={30} />
      <div className="flex-1">
        <Text
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "m",
          }}
        >
          {title}
        </Text>
        <BlockText
          className="break-all"
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "l",
          }}
          weight="bold"
        >
          {description}
        </BlockText>
      </div>
    </div>
  );
}
